import React from 'react';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-heritage text-white py-12 sm:py-16 lg:py-20 xl:py-24 overflow-hidden">
      {/* Heritage Pattern Background */}
      <div className="absolute inset-0 heritage-pattern opacity-10"></div>
      
      {/* Decorative Elements */}
      <div className="absolute top-6 sm:top-10 right-6 sm:right-10 opacity-20 hidden lg:block">
        <Icon name="Feather" size={100} className="text-golden animate-pulse xl:w-[120px] xl:h-[120px]" />
      </div>
      <div className="absolute bottom-6 sm:bottom-10 left-6 sm:left-10 opacity-15 hidden lg:block">
        <Icon name="Palette" size={60} className="text-textile animate-bounce xl:w-20 xl:h-20" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 xl:gap-16 items-center">
          {/* Content */}
          <div className="animate-fade-in">
            <div className="flex items-center space-x-2 sm:space-x-3 mb-3 sm:mb-4 lg:mb-6">
              <div className="w-8 sm:w-10 lg:w-12 h-1 bg-golden thread-weave"></div>
              <span className="text-golden font-poppins font-medium text-xs sm:text-sm lg:text-base">Our Heritage</span>
            </div>
            
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-poppins font-bold mb-3 sm:mb-4 lg:mb-6 leading-tight">
              Premium Fabrics
              <span className="text-golden block">Manufacturer & Wholesaler</span>
            </h1>
            
            <p className="text-sm sm:text-base lg:text-lg xl:text-xl text-white/90 mb-4 sm:mb-6 lg:mb-8 leading-relaxed">
              For over 10 years, Kunjvihari Impex has been the trusted name in fabric manufacturing and wholesale supply. We are experts in manufacturing position print fabrics, blending traditional Indian textile craftsmanship with modern quality standards to deliver premium fabrics including Position Print, Polyester, Natural Crepe, Velvet Embroidery, Chinon, and Shimmer.
            </p>
            
            <div className="flex flex-wrap gap-3 sm:gap-4 lg:gap-6">
              <div className="flex items-center space-x-2 lg:space-x-3">
                <div className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 bg-white/20 rounded-full flex items-center justify-center">
                  <Icon name="Calendar" size={16} className="text-golden sm:w-5 sm:h-5" />
                </div>
                <div>
                  <p className="text-xs sm:text-sm lg:text-base font-semibold">Est. 2014</p>
                  <p className="text-[10px] sm:text-xs lg:text-sm text-white/80">10+ Years Experience</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-2 lg:space-x-3">
                <div className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 bg-white/20 rounded-full flex items-center justify-center">
                  <Icon name="Users" size={16} className="text-golden sm:w-5 sm:h-5" />
                </div>
                <div>
                  <p className="text-xs sm:text-sm lg:text-base font-semibold">1500+ Clients</p>
                  <p className="text-[10px] sm:text-xs lg:text-sm text-white/80">Trusted Worldwide</p>
                </div>
              </div>
            </div>
          </div>

          {/* Video */}
          <div className="relative animate-slide-up order-first lg:order-last">
            <div className="relative rounded-xl sm:rounded-2xl overflow-hidden shadow-heritage">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-56 sm:h-64 md:h-80 lg:h-96 xl:h-[450px] object-cover"
              >
                <source src="/assets/portfolio/Hero_section.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div className="absolute inset-0 bg-gradient-to-t from-primary/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;